import { inject, observer } from 'mobx-react';
import moment from "moment";
import React, { Fragment } from "react";
import {
  ArrowRight, Calendar,
  Share2
} from "react-feather";
import Flatpickr from "react-flatpickr";
import { Link } from 'react-router-dom';
import {
  Button, Col,
  FormGroup, Input,
  InputGroup, InputGroupAddon, Label,
  Modal, ModalBody, ModalHeader, Row
} from "reactstrap";
import "../../../assets/scss/pages/app-chat.scss";
import CreateMeetingStore from "../../../stores/createMeetingStore";
import ContentPreview from "../../elements/contentPreview";
import ContentSelector from "../../elements/contentSelector";
import CustomerActivityCard from "../../elements/customerActivityCard";
import CustomerSelector from "../../elements/customerSelector";
import Invite from "../../elements/newInvite";
import Wizard from "./WizardComponent";
import shareProgressImage from "../../../assets/img/mail-send.gif"
import InputText from '../../common/InputText';

// import Sidebar from "react-sidebar";
// import Gallery from "../../library/components/Gallery";

interface IScheduleMeetingWizardProps {
  createMeetingStore: CreateMeetingStore,
  sessionStore: any,
  meetingId: string,
  onCreateSuccess: Function,
  toggleSliderVisibility: any,
  show: boolean,
  customer?: any
}

interface IScheduleMeetingWizardState {
  showDocumentModal: boolean,
  showCustomerModal: boolean,
  dateTimePicker: any,
  meetDate: any,
  urlCopied: boolean,
  initialStep: number,
  shareableLink: string,
  progressModal: boolean
}

@inject('createMeetingStore', 'sessionStore', 'customerStore')
@observer
class ScheduleMeetingWizard extends React.Component<IScheduleMeetingWizardProps, IScheduleMeetingWizardState> {
  
  constructor(props: IScheduleMeetingWizardProps ) {
    super(props);
    this.state = {
      dateTimePicker: new Date(),
      meetDate: new Date(),
      urlCopied: false,
      initialStep: this.props.meetingId ? 1 : 0,
      showDocumentModal: false,
      showCustomerModal: false,
      shareableLink: "",
      progressModal: false
    }
  }

  componentDidMount() {
    const { createMeetingStore, sessionStore, meetingId } = this.props;
    createMeetingStore.loadMeeting(meetingId, sessionStore.authUser);
    createMeetingStore.loadDocuments();
    createMeetingStore.loadCustomers();
  }

  componentWillUnmount = () => {
    console.log("Component Unmounted");
  }

  toggleDocumentModal = () => {
    this.setState((prevState: IScheduleMeetingWizardState) => ({
      showDocumentModal: !prevState.showDocumentModal
    }))
  }

  toggleCustomerModal = () => {
    this.setState((prevState: IScheduleMeetingWizardState) => ({
      showCustomerModal: !prevState.showCustomerModal
    }))
  }

  setTitle = (e: any) => {
    const { createMeetingStore } = this.props;
    createMeetingStore.setTitle(e.target.value);
  }

  setDocument = (o: any) => {
    const { createMeetingStore } = this.props;
    createMeetingStore.setDocument(o.value);
  }

  setCustomer = (o: any) => {
    const { createMeetingStore } = this.props;
    createMeetingStore.setCustomer(o.value);
  }

  setMeetingDate = (datetime: any) => {
    const { createMeetingStore } = this.props;
    let dateObj = new Date(createMeetingStore.meeting.startTime)
    if (datetime && datetime.length == 1) {
      if (createMeetingStore.meeting.startTime != 0) {
        dateObj.setMonth(datetime[0].getMonth())
        dateObj.setFullYear(datetime[0].getFullYear())
        dateObj.setDate(datetime[0].getDate())
        createMeetingStore.setStartTime(dateObj.getTime());
        createMeetingStore.setEndTime(dateObj.getTime() + 30 * 60000)
      }
      else {
        createMeetingStore.setStartTime(datetime[0].getTime());
      }
    }
  }

  setStartTime = (datetime: any) => {
    console.log(datetime)
    const { createMeetingStore } = this.props;
    let dateObj = new Date(createMeetingStore.meeting.startTime)
    if (datetime && datetime.length == 1) {
      if (createMeetingStore.meeting.startTime != 0) {
        dateObj.setHours(datetime[0].getHours())
        dateObj.setMinutes(datetime[0].getMinutes())
        createMeetingStore.setStartTime(dateObj.getTime());
      }
      else {
        createMeetingStore.setStartTime(datetime[0].getTime());
      }
    }
  }

  setEndTime = (datetime: any) => {
    const { createMeetingStore } = this.props;
    let dateObj = new Date(createMeetingStore.meeting.startTime)
    if (datetime && datetime.length == 1) {
      if (createMeetingStore.meeting.startTime != 0) {
        dateObj.setHours(datetime[0].getHours())
        dateObj.setMinutes(datetime[0].getMinutes())
        createMeetingStore.setEndTime(dateObj.getTime());
      }
      else {
        createMeetingStore.setEndTime(datetime[0].getTime());
      }
    }
  }

  saveMeeting = (i: any) => {
    if (i == 0) {
      const { createMeetingStore, sessionStore } = this.props;
      const { authUser } = sessionStore
      createMeetingStore.saveMeeting(authUser);
    }
    else {
      this.props.onCreateSuccess();
    }
  }

  // toggleModal = () => {
  //   this.setState((prevState: IScheduleMeetingWizardState) => ({
  //     progressModal: !prevState.progressModal,

  //   }))
  // }

  shareMeeting = (shareVia: any) => {
    const { createMeetingStore, sessionStore } = this.props;
    const { authUser } = sessionStore
    createMeetingStore.shareMeeting(shareVia, authUser);
  }

  generateShareCode = () => {
    const { createMeetingStore, sessionStore } = this.props;
    const { authUser } = sessionStore
    createMeetingStore.createShareableCode(authUser);
  }


  render() {
    const { createMeetingStore } = this.props;
    const { meeting, documentList, customerList, shareUrl, sharing, errors } = createMeetingStore;
    // const { presenter } = meeting;
    // const presenterId = presenter == null ? "" : presenter.id;
    const docOptions: any = documentList ? documentList.map((doc: any) => {
      return { value: doc, label: doc.name }
    }) : []

    const custOptions: any = customerList ? customerList.map((cust: any) => {
      return { value: cust, label: cust.account.firstName + ' ' + cust.account.lastName }
    }) : []

    const selectedDocId = meeting.uid ? meeting.presentation.docId : null
    const selectedDocIndex = selectedDocId ? docOptions.findIndex((doc: any) => doc.value.uid === selectedDocId) : null;
    const docName = meeting.presentation ? meeting.presentation.name : null;

    const selectedCustId = meeting.uid ? meeting.participants && meeting.participants[0].id : this.props.customer ? this.props.customer.uid : null;
    const selectedCustIndex = selectedCustId ? custOptions.findIndex((cust: any) => cust.value.uid === selectedCustId) : null;
    const cusName = meeting.participants && meeting.participants.length > 0
      ? meeting.participants[0].displayName
      : selectedCustIndex > -1
        ? custOptions[selectedCustIndex] && custOptions[selectedCustIndex].label
        : null;
    const meetingDate = meeting.uid && meeting.startTime ? moment(meeting.startTime, 'x').toDate() : new Date()
    const startTime = meetingDate;
    const endTime = meeting.uid && meeting.endTime ? moment(meeting.endTime, 'x').toDate() : new Date(startTime.getTime() + 30 * 60000);
    const slides = meeting.presentation == null ? [] : meeting.presentation.slides;
    const isFormValid = meeting.title && meeting.presentation.docId && meeting.participants && meeting.participants.length > 0 && meeting.participants[0].id && (meeting.endTime > meeting.startTime) ? true : false;
    const meetingUid = meeting.uid == "" ? null : meeting.uid;
    const presenterId = meeting.presenter ? meeting.presenter.id : null;
    // meeting.shareUrl = shareUrl == null || shareUrl == "" ? meeting.shareUrl : shareUrl;

    const documentModal = (<Modal
      isOpen={this.state.showDocumentModal}
      className="modal-dialog-centered modal-xl"
    >
      <div className="sidebar_header">
        <span className="heading">Select Content</span>
        <div>
          <Button
            color="danger"
            outline
            className="btn ml-1"
            onClick={this.toggleDocumentModal}
          >
            Cancel
            </Button>
        </div>
      </div>
      <div className="sidebar_content">
        <ContentSelector
          contentSharing="meeting"
          toggle={this.toggleDocumentModal}
        />
      </div>
    </Modal>)

    const customerModal = (<Modal
      isOpen={this.state.showCustomerModal}
      className="modal-dialog-centered modal-xl"
    >
      <div className="sidebar_header">
        <span className="heading">Select Content</span>
        <div>
          <Button
            color="danger"
            outline
            className="btn ml-1"
            onClick={this.toggleCustomerModal}
          >
            Cancel
            </Button>
        </div>
      </div>
      <div className="sidebar_content">
        <CustomerSelector
          contentSharing="meeting"
          toggle={this.toggleCustomerModal}
        />
      </div>
    </Modal>)

    /*const meetingLink = meetingUid ? (
          meeting.status == "END" ? (
              <span>
                <Button disabled={true} color="primary">Meeting Over!</Button>
              </span>
            ) : (
              <span>
                <Link to={`/meeting/${meetingUid}`}>
                  <Button color="primary">Go To Meeting</Button>
                </Link>
              </span>
            )
        ) : (
          <span>
            <Button disabled={true} color="primary">Meeting Over!</Button>
          </span>
        );*/

    const form =
      <div>
        <div>
          <Row>
            <Col lg="10" md="10" sm="10">
              <InputText
                type="text"
                label="Meeting Title"
                value={meeting.title}
                name="title"
                showRequired={true}
                placeholder="Meeting Title"
                onChange={e => this.setTitle(e)}
                id="title"
                error={errors.title}
                />
              {/*<FormGroup>
                <Label for="customer">Meeting Title</Label>
                <Input
                  type="text"
                  value={meeting.title || ''}
                  name="title"
                  required
                  placeholder="Meeting Title"
                  onChange={e => this.setTitle(e)}
                  id="data-name"
                />
              </FormGroup>*/}
              
              <FormGroup>
                <Label for="customer">Select Customer</Label>
                <InputGroup>
                  <Input
                    type="text"
                    placeholder="Select Customer"
                    value={cusName || "" }
                  />
                  <InputGroupAddon addonType="append">
                    <Button
                      className="button"
                      color="primary"
                      onClick={this.toggleCustomerModal}
                    >
                      Select Customer
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>

              <FormGroup>
                <Label for="customer">Select Document</Label>
                <InputGroup>
                  <Input
                    type="text"
                    placeholder="Select Document"
                    value={docName || ""}
                  />
                  <InputGroupAddon addonType="append">
                    <Button
                      className="button"
                      color="primary"
                      onClick={this.toggleDocumentModal}
                    >
                      Select Document
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
              {/* <FormGroup>
								<Label for="document">Document</Label>
								<Select
									className="React"
									id="document"
									classNamePrefix="select"
									value={docOptions[selectedDocIndex]}
									onChange={o => this.setDocument(o)}
									name="loading"
									options={docOptions}
									isLoading={false}
								/>
							</FormGroup> */}
              {/* <FormGroup className="mr-3">
                <Label htmlFor="meetingDate">Meeting Date</Label>
                <Input
                  type="date"
                  name="date"
                  id="meetingDate"
                  value={meetingDate ? new Date(meetingDate) : ""}
                  onChange={e => {
                    this.setMeetingDate([new Date(e.target.value)]);
                  }}
                />
              </FormGroup> */}

              <FormGroup>
                <Label for="meetingDate">Meeting Date</Label>
                <Flatpickr
                  className="form-control"
                  value={meetingDate}
                  id="meetingDate"
                  onChange={date => {
                    this.setMeetingDate(date);
                  }}
                />
              </FormGroup>
              <Row>
                <Col>
                  <FormGroup>
                    <Label for="startTime">Start Time</Label>
                    <Flatpickr
                      className="form-control"
                      id="startTime"
                      value={startTime}
                      options={{
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: "h:i K",
                        minTime: "08:00",
                        maxTime: "22:30",
                        minuteIncrement: 15,
                        defaultMinute: 45
                      }}
                      onChange={date => {
                        this.setStartTime(date);
                      }}
                    />
                  </FormGroup>
                  {/* <FormGroup>
                    <Label htmlFor="date_time">Time</Label>
                    <Input
                      type="time"
                      name="time"
                      id="startTime"
                      onChange={(e)=>{console.log(e.target.value)}}
                    />
                  </FormGroup> */}
                </Col>
                <Col>
                  <FormGroup>
                    <Label for="endTime">End Time</Label>
                    <Flatpickr
                      className="form-control"
                      id="endTime"
                      value={endTime}
                      options={{
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: "h:i K",
                        minuteIncrement: 15,

                      }}
                      onChange={date => {
                        this.setEndTime(date);
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>

    const preview =
      <div style={{ height: "100%" }}>
        {
          cusName
            ? <CustomerActivityCard
              customerName={cusName}
              data={[
                {
                  title: "Last Meeting",
                  value: "10 days ago"
                },
                {
                  title: "Content shared in this week",
                  value: "3 times"
                }, {
                  title: "Overall sharing frequency",
                  value: "4/week"
                },
                {
                  title: "Engagement Rating",
                  value: "3.45"
                }
              ]}
            />
            : <div className="d-flex justify-content-center align-items-center" style={{ height: "200px", border: "1px solid #eee"}}>
              <h6 className="text-muted">Please select customer</h6>
              </div>
        }
        {
          docName
            ? <div className="mt-4">
              <ContentPreview data={slides} height="200px" />
            </div>
            : <div className="d-flex justify-content-center align-items-center mt-2" style={{ height: "200px", border: "1px solid #eee" }}>
                <h6 className="text-muted">Please choose content</h6>
              </div>
        }
      </div>

    const mailSendModal = 
        <Fragment>
          <Modal
            isOpen={sharing}
            returnFocusAfterClose={false}
            className="modal-dialog-centered modal-lg"
          >
            <ModalBody className="modal-dialog-centered">
             <img 
              src={shareProgressImage}
              className="progress-image"
             />
            </ModalBody>
          </Modal>
        </Fragment>
    
    const timeLine =
      <Fragment>
        {
          selectedCustId
            ? 
              <Fragment>
                <Invite
                  shareable_link={meeting.shareUrl == null || meeting.shareUrl == "" ? shareUrl : meeting.shareUrl}
                  customer_name={cusName}
                  content_title={docName}
                  generateCode={ (e:any) => this.generateShareCode() }
                  share={ (shareVia: any) => this.shareMeeting(shareVia)}
                />
              </Fragment>
            : <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
              <h4 className="text-muted">Select customer to share content with...</h4>
            </div>
        }
      </Fragment>


    const details =
      <div>
        <div className="d-flex user-info">
          <p className="user-info-title font-weight-bold">Date & Time: &nbsp;</p>
          <div className="text-truncate ml-5p">
            <span>
              {new Date(meeting.startTime).toDateString().slice(0, 10)}&nbsp;
                ({new Date(meeting.startTime).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }).slice(0, 10)} -
                &nbsp;{new Date(meeting.endTime).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }).slice(0, 10)})
              </span>
          </div>
        </div>

        <div className="mt-2">
          {
            selectedCustId
              ? <CustomerActivityCard
                style={{ width: "auto" }}
                customerName={cusName}
                data={[
                  {
                    title: "Last Meeting",
                    value: "10 days ago"
                  },
                  {
                    title: "Content shared in this week",
                    value: "3 times"
                  }, {
                    title: "Overall sharing frequency",
                    value: "4/week"
                  },
                  {
                    title: "Engagement Rating",
                    value: "3.45"
                  }
                ]}
              />
              : <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                  <h5>No Customer Selected.</h5>
                </div>
          }
        </div>

        <div className="mt-2">
          {
            docName
              ? <ContentPreview data={slides} height="200px" />
              : <div className="d-flex justify-content-center align-items-center" style={{height: "200px"}}>
                  <h5 className="text-muted">No Document Selected.</h5>
                </div>
          }
        </div>
      </div>

    const steps = [
      {
        title: <Calendar className="firstOne" size={20} />,
        content:
          <Row className="mb-3">
            <Col xs={12} md={6} lg={7}>{form}</Col>
            <Col xs={12} md={6} lg={5}>{preview}</Col>
          </Row>

      }, {
        title: <Share2 size={20} />,
        content:
          <Row className="mt-2" style={{ minHeight: "500px" }}>
            <Col xs={12} md={6} lg={5}>{details}</Col>
            <Col xs={12} md={6} lg={7}>{timeLine}</Col>
          </Row>
      }
    ]

    return (
      <div className="animation-slider-sidebar">
        <div className="sidebar_header">
          {
            !this.state.initialStep
              ? <span className="heading">Schedule Meeting</span>
              : <span className="heading">{docName}</span>
          }
          <div>
            {meeting.uid
              ? <Fragment>
                <Link to={`/meeting/${meeting.uid}`} className="primary">
                  <Button
                    className="btn ml-1"
                    color="primary">
                    Start
                  </Button>
                </Link>
                <Button
                  className="btn ml-1"
                  outline
                  // onClick={() => { this.ref.handlePreviousStep() }}
                  color="primary">
                  Edit
                  </Button>
              </Fragment>
              : null
            }

            <Button
              className="btn ml-1"
              outline
              color="danger"
              onClick={this.props.toggleSliderVisibility}
            >
              Cancel
            </Button>
          </div>
        </div>
        <div className="sidebar_content" >
          <Wizard
            // onFinish={() => alert("submitted")}
            enableAllSteps={this.props.meetingId ? true : false}
            // ref={this.refer}
            steps={steps}
            pagination={true}
            activeStep={this.state.initialStep}
            isValid={!isFormValid}
            nextBtnFunc={this.saveMeeting}
            nextBtnText={meeting.uid ? 'Update' : 'Schedule'}
            nextBtnIcon={<ArrowRight size={16} />}
          />
        </div >
        {documentModal}
        {customerModal}
        {mailSendModal}
      </div>

    )
  }
}

export default ScheduleMeetingWizard;
